export const uploadPageinputNumberStyle = (e: any): object => {
    const uploadPageinputNumberStyle = {
        width: '200px',
        input: {
            fontWeight: 'bold',
            '&::placeholder': {
                fontWeight: 'normal',
            },
            '&:focus': {
                background: '#F6F6F6',
            },
            background: `${!e.valueBin && '#F6F6F6'}`,
        },
    };

    return uploadPageinputNumberStyle;
};

export const UploadZoneDropDown = {
    backgroundColor: 'white',
    '& > .MuiInputBase-root': {
        backgroundColor: '#F6F6F6',
    },
};

export const uploadPageboxParentStyle = {
    display: 'flex',
    gap: '1.25rem',
    alignItems: 'flex-start',
    marginTop: '1.25rem',
};

export const UploadPageNextButton = {
    marginTop: '10px',
};
export const UploadPageInformationTooltip = {
    marginTop: '35px',
    marginLeft: '10px',
};

export const uploadPageboxChildStyle = (e: any): object => {
    const uploadPageboxChildStyle = {
        width: '100%',
        pointerEvents: `${e.uploadZone && 'none'}`,
    };
    return uploadPageboxChildStyle;
};
